import React from "react";
import { Dialog, Button } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const DynamicForwardUpgradeModal = ({ open, onUpgrade, onCancel }) => {
  const handleClose = (_event, reason) => {
    if (reason === "backdropClick") return;
    onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "14px",
          padding: "28px",
        },
      }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0,0,0,0.35)" },
      }}
    >
      <div className="flex items-center gap-2 mb-4">
        <InfoOutlinedIcon className="text-amber-500" sx={{ fontSize: 28 }} />
        <h2 className="text-[22px] font-semibold text-gray-800">
          Team Plan required
        </h2>
      </div>

      <p className="text-gray-600 text-[15px] leading-relaxed mb-6">
        Dynamic Forward routes incoming calls to the assigned user on a contact record.
        Upgrade to the <strong>Team Plan</strong> to use this feature.
      </p>

      <div className="flex justify-end gap-3">
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={{
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
            color: "#374151",
            borderColor: "#D1D5DB",
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onUpgrade}
          sx={{
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
          }}
        >
          View plans
        </Button>
      </div>
    </Dialog>
  );
};

export default DynamicForwardUpgradeModal;
